(function ($) {
	var mq = window.matchMedia("(min-width: 1025px)");
	$(function () {
		if (matchMedia) {
			mq.addListener(WidthChange);
			WidthChange(mq);
		}
		function WidthChange(mq) {
			if (mq.matches) {
				$(".js-accordion--sp").removeClass("is-open");
				$(".js-accordion--sp").next().slideDown();
			} else {
			}
		};

		$(".js-accordion--sp").on("click", function(){
			var $ww = $(window).innerWidth();
			if($ww < 1025){
				$(this).toggleClass("is-open");
				$(this).next().slideToggle();
			}
		});
	});
})(jQuery);
